module.exports = __webpack_public_path__ + "assets/media/bold.a2002c35.svg";